import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _define_property from "@swc/helpers/src/_define_property.mjs";
import _inherits from "@swc/helpers/src/_inherits.mjs";
import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import _create_super from "@swc/helpers/src/_create_super.mjs";
import invariant from "tiny-invariant";
import { ChainId } from "../constants";
import { validateAndParseAddress } from "../utils";
import { Currency } from "./currency";
/**
 * Represents an ERC20 token with a unique address and some metadata.
 */ export var Token = /*#__PURE__*/ function(Currency) {
    "use strict";
    _inherits(Token, Currency);
    var _super = _create_super(Token);
    function Token(chainId, address, decimals, symbol, name, projectLink) {
        _class_call_check(this, Token);
        var _this;
        _this = _super.call(this, decimals, symbol, name);
        _this.chainId = chainId;
        _this.address = validateAndParseAddress(address);
        _this.projectLink = projectLink;
        return _this;
    }
    var _proto = Token.prototype;
    /**
   * Returns true if the two tokens are equivalent, i.e. have the same chainId and address.
   * @param other other token to compare
   */ _proto.equals = function equals(other) {
        // short circuit on reference equality
        if (this === other) {
            return true;
        }
        return this.chainId === other.chainId && this.address === other.address;
    };
    /**
   * Returns true if the address of this token sorts before the address of the other token
   * @param other other token to compare
   * @throws if the tokens have the same address
   * @throws if the tokens are on different chains
   */ _proto.sortsBefore = function sortsBefore(other) {
        invariant(this.chainId === other.chainId, "CHAIN_IDS");
        invariant(this.address !== other.address, "ADDRESSES");
        return this.address.toLowerCase() < other.address.toLowerCase();
    };
    return Token;
}(Currency);
/**
 * Compares two currencies for equality
 */ export function currencyEquals(currencyA, currencyB) {
    if (_instanceof(currencyA, Token) && _instanceof(currencyB, Token)) {
        return currencyA.equals(currencyB);
    } else if (_instanceof(currencyA, Token)) {
        return false;
    } else if (_instanceof(currencyB, Token)) {
        return false;
    } else {
        return currencyA === currencyB;
    }
}
var _obj;
export var WETH = (_obj = {}, _define_property(_obj, ChainId.OP_MAINNET, new Token(ChainId.OP_MAINNET, "0x4200000000000000000000000000000000000006", 18, "WETH", "Wrapped WETH", "")), _define_property(_obj, ChainId.OP_SEPOLIA, new Token(ChainId.OP_SEPOLIA, "0x4200000000000000000000000000000000000006", 18, "WETH", "Wrapped ETH", "")), _define_property(_obj, ChainId.BASE, new Token(ChainId.BASE, "0x4200000000000000000000000000000000000006", 18, "WETH", "Wrapped WETH", "")), _define_property(_obj, ChainId.SEPOLIA, new Token(ChainId.SEPOLIA, "0x7b79995e5f793a07bc00c21412e50ecae098e7f9", 18, "WETH", "Wrapped ETH", "")), _define_property(_obj, ChainId.ARBITRUM_ONE, new Token(ChainId.ARBITRUM_ONE, "0x82af49447d8a07e3bd95bd0d56f35241523fbab1", 18, "WETH", "Wrapped ETH", "")), _define_property(_obj, ChainId.POLYGON, new Token(ChainId.POLYGON, "0x7ceb23fd6bc0add59e62ac25578270cff1b9f619", 18, "WETH", "Wrapped ETH", "")), _define_property(_obj, ChainId.HEIF_LAYER, new Token(ChainId.HEIF_LAYER, "0x7b79995e5f793a07bc00c21412e50ecae098e7f9", 18, "WETH", "Wrapped ETH", "")), _obj);
var _obj1;
export var WNATIVE = (_obj1 = {}, _define_property(_obj1, ChainId.SEPOLIA, WETH[ChainId.SEPOLIA]), _define_property(_obj1, ChainId.OP_MAINNET, WETH[ChainId.OP_MAINNET]), _define_property(_obj1, ChainId.OP_SEPOLIA, WETH[ChainId.OP_SEPOLIA]), _define_property(_obj1, ChainId.BASE, WETH[ChainId.BASE]), _define_property(_obj1, ChainId.HEIF_LAYER, WETH[ChainId.HEIF_LAYER]), _define_property(_obj1, ChainId.POLYGON, WETH[ChainId.POLYGON]), _define_property(_obj1, ChainId.ARBITRUM_ONE, WETH[ChainId.ARBITRUM_ONE]), _obj1);
